import styled from 'styled-components';

export const CSSEditor = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 10px;
`;

export const CSSEditorWidgetProperties = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 10px;
`;

export const CSSEditorWarning = styled.div`
    border: 1px dashed ${(props) => props.theme.color.orange};
    border-radius: 4px;
    color: ${(props) => props.theme.color.orange};
    padding: 8px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CSSEditorComponentWrapper = styled.div`
    margin-bottom: 0px;
`;

export const CSSEditorComponentLabel = styled.div`
    margin-bottom: 4px;
`;

export const CSSEditorComponentDescription = styled.div`
    margin-bottom: 4px;
    color: ${(props) => props.theme.color.grey4};
`;
